import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, P, useText } from "@sveabank/cc-common";

type Props = {
	open: boolean;
	setOpen: (isOpen: boolean) => void;
	onDelete: () => Promise<void>;
	loading: boolean;
};

const DeleteApplicationModal = ({ open, setOpen, onDelete, loading }: Props) => {
	const [t, texts] = useText();

	const onDeleteClick = async () => {
		await onDelete();
		setOpen(false);
	};

	return (
		<Dialog
			isOpen={open}
			setOpen={setOpen}
			center
			size="small"
			heading={t(texts.header.abortApplicationModal.title)}
			icon="warning"
		>
			<Dialog.Content>
				<P>{t(texts.header.abortApplicationModal.description)}</P>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button onPress={onDeleteClick} isPending={loading}>
						{t(texts.common.continue)}
					</Button>
					<Button variant="secondary" onPress={() => setOpen(false)}>
						{t(texts.common.goBack)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};

export default DeleteApplicationModal;
